import React, { FC } from 'react';
import moment from 'moment/moment';
import { StockModelCardHeaderProps } from '.';
import useTranslations from '@hooks/useTranslations';
import { IPromo } from '../../../../interfaces/IOfferItem';
import { EContextPage } from '@utils/Promo.utils';
import MarketingSticker from '@components/MarketingSticker';
import CarNumber from '@components/v2/CarNumber';
import DemoVehicleLabel from '@components/DemoVehicleLabel';
import { formatDateByLang } from '@utils/Date.utils';
import { DEMO_VEHICLE_DEFAULT_DATE_FORMAT } from '../../../../constants/main';

export const StockModelCardHeaderTemplate: FC<StockModelCardHeaderProps> = ({
    className,
    isUnderlineDisplayed = false,
    title,
    stockCount,
    engineInfo,
    allModelsCount,
    isBooked,
    isStockSlice,
    specPackTitle,
    isMarketingStickerEnabled,
    isPromoEnabled,
    hasPromoCode,
    numCar,
    mileage,
    registrationDate,
    VDStatus,
}) => {
    const { t } = useTranslations();

    return (
        <div className={className}>
            <header className={`stockModelCard-header`}>
                {Boolean(isMarketingStickerEnabled) && (
                    <section className="carMarketingSticker">
                        <MarketingSticker
                            data={isMarketingStickerEnabled as unknown as Array<IPromo>}
                            page={EContextPage.trim}
                        />
                    </section>
                )}
                <div className="title-flexWrapper">
                    {isStockSlice ? (
                        <h2 className={`stockModelCard-header--heading ${VDStatus ? 'withDemoLabel' : ''}`}>
                            {title}
                            <span className="specPack">&nbsp;{specPackTitle}</span>
                        </h2>
                    ) : (
                        <h3 className={`stockModelCard-header--heading ${VDStatus ? 'withDemoLabel' : ''}`}>{title}</h3>
                    )}

                    {!!allModelsCount && (
                        <span className="stockModelCard-header--allModelCount">
                            {t('stockModelCard.totalCount', { count: allModelsCount })}
                        </span>
                    )}
                    {!!stockCount && (
                        <div className={`stockModelCard-header--stockCount ${stockCount === 1 && 'lastItem'}`}>
                            {t('stockModelCard.stockCount', { count: stockCount })}
                        </div>
                    )}
                    {/* TODO this will make use of some kind of promotion related property (not isBooked). Waiting for VDE / clarification */}
                    {/* TODO when implementing the new property, dont forget to delete isBooked from props as well */}
                    {/*{isBooked && (*/}
                    {/*    <div className="stockModelCard-header--stockCount lastItem">{t('stockModelCard.isBooked')}</div>*/}
                    {/*)}*/}
                </div>
                {engineInfo && (
                    <div className="stockModelCard-header--info">
                        <div className="stockModelCard-header--engineInfo">
                            {engineInfo.map((item: string, index: number) => (
                                <span key={index}>{item}</span>
                            ))}
                        </div>
                    </div>
                )}
                {numCar && <CarNumber numCar={numCar} />}
                {VDStatus && <DemoVehicleLabel status={VDStatus} isTrim />}
                {registrationDate && (
                    <div className="stockModelCard-header--demoInfo">
                        <span>
                            <span className="stockModelCard-header--demoInfo---label">{t('vehicle.demo.mileage')}</span>
                            {new Intl.NumberFormat().format(Number(mileage))}{' '}
                            {t('checkout.delivery.dealer.item.distance')}
                        </span>
                        <span>
                            <span className="stockModelCard-header--demoInfo---label">
                                {t('vehicle.demo.registrationDate')}
                            </span>
                            {formatDateByLang(moment(registrationDate, DEMO_VEHICLE_DEFAULT_DATE_FORMAT).toDate())}
                        </span>
                    </div>
                )}
            </header>

            {isUnderlineDisplayed && <hr className="stockModelCard-separator" />}
        </div>
    );
};

export default StockModelCardHeaderTemplate;
